module.exports = __webpack_public_path__ + "img/no_pic_unitkerja.bd1dbffa.png";